import api from './axiosInstance';

export interface SearchResultItem {
  _id: string;
  label: string;
  sublabel?: string;
  href: string;
}

export interface SearchResults {
  tasks: SearchResultItem[];
  projects: SearchResultItem[];
  clients: SearchResultItem[];
}

export const globalSearch = async (q: string): Promise<SearchResults> => {
  const { data } = await api.get<SearchResults>('/search', { params: { q } });
  return data;
};
